import Vue from 'vue';
import axios, { AxiosInstance, AxiosRequestConfig, AxiosError, AxiosResponse } from 'axios';
import urlJoin from 'url-join';
import store from '@/store';
import { config as appConfig } from '@/config';

const HttpService: AxiosInstance = axios.create();

HttpService.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const url: string = config.url || '';

    if (!/^(?:\w+:)\/\//.test(url)) {
      const localeCode: string = store.getters['app/locale'];
      config.url = urlJoin(appConfig.api.endpoint, localeCode, url);
    }

    return config;
  },

  (error: AxiosError) => {
    return Promise.reject(error);
  },
);

HttpService.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },

  (error: AxiosError) => {
    return Promise.reject(error);
  },
);

class HttpServicePlugin {
  public static install(vue: typeof Vue, options?: any) {
    if (!vue.prototype.$http) {
      Object.defineProperties(vue.prototype, {
        $http: {
          get() {
            return HttpService;
          },
        },
      });
    }
  }
}

export { HttpService as default, HttpServicePlugin };
